import angular from 'angular';
import { StateRegistry } from '@uirouter/angularjs';

import { r2a } from '@/react-tools/react2angular';
import {
  ListView,
  CreateView,
  EditView,
} from '@/react/portainer/environments/update-schedules';
import { withUIRouter } from '@/react-tools/withUIRouter';
import { withReactQuery } from '@/react-tools/withReactQuery';
import { withCurrentUser } from '@/react-tools/withCurrentUser';

export const updateSchedulesModule = angular
  .module('portainer.edge.updateSchedules', [])
  .component(
    'updateSchedulesListView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(ListView))), [])
  )
  .component(
    'updateSchedulesCreateView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(CreateView))), [])
  )
  .component(
    'updateSchedulesEditView',
    r2a(withUIRouter(withReactQuery(withCurrentUser(EditView))), [])
  )
  .config(config).name;

function config($stateRegistryProvider: StateRegistry) {
  $stateRegistryProvider.register({
    name: 'portainer.endpoints.updateSchedules',
    url: '/update-schedules',
    views: {
      'content@': {
        component: 'updateSchedulesListView',
      },
    },
    data: {
      docs: '/admin/environments/update',
    },
  });

  $stateRegistryProvider.register({
    name: 'portainer.endpoints.updateSchedules.new',
    url: '/new',
    views: {
      'content@': {
        component: 'updateSchedulesCreateView',
      },
    },
  });

  $stateRegistryProvider.register({
    name: 'portainer.endpoints.updateSchedules.edit',
    url: '/:id/edit',
    views: {
      'content@': {
        component: 'updateSchedulesEditView',
      },
    },
  });
  // This view is meant to display the environment details of the update. Please, do not delete
  $stateRegistryProvider.register({
    name: 'portainer.endpoints.updateSchedules.item',
    url: '/:id',
    views: {
      'content@': {
        component: 'updateSchedulesEditView',
      },
    },
  });
}
